// extracted by mini-css-extract-plugin
module.exports = {"className":"textBodyL_className__8D1Ya"};